import React, { useContext, useEffect } from 'react';
import { Redirect, Route } from "react-router";
import PropTypes from 'prop-types';
import { OidcContext, userManager } from "../OidcContext";
import CONSTANTS from '../../common/constants';

const AuthenticatedRoute = ({ component: Component, requiresAuthorization, ...rest }) => {
  const { isAuthorized, isAuthenticated } = useContext(OidcContext);

  useEffect(() => {
    (async () => {
      if (!isAuthenticated()) {
        await userManager.signinRedirect();
      }
    })();
  }, [ isAuthenticated ]);

  return isAuthenticated()
      ? requiresAuthorization
        ? (
          <Route
            {...rest}
            render={props =>
              isAuthorized() ? (
                <Component {...props} />
              ) : (
                <Redirect
                  to={{
                    pathname: `${CONSTANTS.ROUTE.FORBIDDEN}`,
                    state: { from: props.location }
                  }}
                />
              )
            }
          />
        )
        : <Route {...rest} component={Component} />
      : null;
};

AuthenticatedRoute.propTypes = {
  component: PropTypes.node,
  location: PropTypes.string
};

export default AuthenticatedRoute;